module.exports = "/fonts/fa-brands-400.ttf?7febe26eeb4dd8e3a3c614a144d399fb";